import { createSlice, createSelector } from "@reduxjs/toolkit";
const MODULE_MANAGER_FEATURE_KEY = "moduleManager";
const initialModuleManagerState = {
  modules: {}
};
const moduleManagerSlice = createSlice({
  name: MODULE_MANAGER_FEATURE_KEY,
  initialState: initialModuleManagerState,
  reducers: {
    setModuleLoaded: (state, { payload }) => {
      if (!state.modules[payload]) {
        state.modules[payload] = true;
      }
    },
    removeModuleLoaded: (state, { payload }) => {
      delete state.modules[payload];
    }
  }
});
const {
  setModuleLoaded,
  removeModuleLoaded
} = moduleManagerSlice.actions;
const moduleManagerReducer = moduleManagerSlice.reducer;
const getModuleManagerState = (rootState) => rootState[MODULE_MANAGER_FEATURE_KEY];
const selectModuleLoaded = createSelector(
  getModuleManagerState,
  (s, name) => name,
  (s, name) => s.modules[name]
);
export {
  MODULE_MANAGER_FEATURE_KEY,
  getModuleManagerState,
  initialModuleManagerState,
  moduleManagerReducer,
  moduleManagerSlice,
  removeModuleLoaded,
  selectModuleLoaded,
  setModuleLoaded
};
